import { formatDate, formatMoney, formatNumber } from '@/lib/format';
import type { Customer, FieldValue as StoredValue, ListField } from '@/types/platform';

interface FieldValueProps {
  field: ListField;
  value: StoredValue | undefined;
  customers?: Customer[];
}

// Shows one stored value the way its field type reads to a person.
export default function FieldValue({ field, value, customers = [] }: FieldValueProps) {
  if (value === null || value === undefined || value === '') {
    return <span className="text-muted-foreground">—</span>;
  }

  if (field.type === 'money' && typeof value === 'number') return <>{formatMoney(value)}</>;
  if (field.type === 'number' && typeof value === 'number') return <>{formatNumber(value)}</>;
  if (field.type === 'date' && typeof value === 'string') return <>{formatDate(value)}</>;
  if (field.type === 'checkbox') return <>{value ? 'Yes' : 'No'}</>;

  if (field.type === 'customer') {
    const customer = customers.find((candidate) => candidate.id === value);

    return <>{customer ? customer.name : 'Unknown customer'}</>;
  }

  if (field.type === 'location' && typeof value === 'object') {
    return (
      <>
        {value.lat.toFixed(5)}, {value.lng.toFixed(5)}
      </>
    );
  }

  return <>{String(value)}</>;
}
